import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../../../libs/utils/constants/async-status';
import IMyLearning from '../../../../../libs/utils/interfaces/my-learning-interface';
import {
    getPendingAssignment,
    getAllUserAssignmentCoursesById,
} from './my-learning-card-thunk';

const initialState: IMyLearning = {
    pendingAssignmentAsyncStatus: AsyncStatus.INITIAL,
    userAssignmentCoursesAsyncStatus: AsyncStatus.INITIAL,
    assignment: null,
    userAssignmentCourses: {},
    type: null,
};

const myLearningSlice = createSlice({
    name: 'myLearning',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            // fetch Assignment list
            .addCase(getPendingAssignment.pending, (state) => {
                state.pendingAssignmentAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(getPendingAssignment.fulfilled, (state, action) => {
                const { payload } = action;
                const { assignment, type } = payload;
                state.assignment = assignment;
                state.type = type;
                state.pendingAssignmentAsyncStatus = AsyncStatus.SUCCESS;
            })
            .addCase(getPendingAssignment.rejected, (state) => {
                state.pendingAssignmentAsyncStatus = AsyncStatus.FAILURE;
            })
            // get User Assignment Courses
            .addCase(getAllUserAssignmentCoursesById.pending, (state) => {
                state.userAssignmentCoursesAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                getAllUserAssignmentCoursesById.fulfilled,
                (state, action) => {
                    state.userAssignmentCourses = {
                        ...state.userAssignmentCourses,
                    };
                    state.userAssignmentCoursesAsyncStatus =
                        AsyncStatus.SUCCESS;
                    state.userAssignmentCourses = action.payload;
                }
            )
            .addCase(getAllUserAssignmentCoursesById.rejected, (state) => {
                state.userAssignmentCoursesAsyncStatus = AsyncStatus.FAILURE;
            });
    },
});

export default myLearningSlice.reducer;
